module.exports = function getResource(label, vars = []) {
    let resources = {
        promoWarning: 'Promo/Reward Code Warning',
        promoConfirmationTitle: 'Promotion Redeemed',
        promoConfirmationMessage: 'Your promotion has been added to your basket.',
        ok: 'OK',
        promoErrorTitle: 'Promo Error'
    };

    return resources[label];
};
